import { EventBus } from '@/event-bus';
import Vue from 'vue';

export default Vue.extend({
  methods: {
    openModal(template): void {
      EventBus.$emit('openModal', template);
    },
  },
});
